import { render } from "./Definition_of_basic_measures.vue?vue&type=template&id=3657e2ae&scoped=true"
import script from "./Definition_of_basic_measures.vue?vue&type=script&lang=js"
export * from "./Definition_of_basic_measures.vue?vue&type=script&lang=js"

import "./Definition_of_basic_measures.vue?vue&type=style&index=0&id=3657e2ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3657e2ae"]])

export default __exports__